$(document).ready(function() {
  const attachmentInput = $("input[name='attachment']")
  attachmentInput.on('change', function(e) {
    if (e.target.files.length > 0 && !$('.remove-attachment').length) {
      attachmentInput.parent().append("<div class='remove-attachment'></div>")
      $('.remove-attachment').on('click', function() {
        attachmentInput[0].value = ''
        this.remove()
      })
    }
  })
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/attachment-cancel.js